import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';

import { RouterLink } from 'src/routes/components';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  version?: 'white' | 'blue';
  width?: number;
  height?: number;
  url?: string;
  customLogo?: string;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, version = 'white', height = 'auto', url = '/', width = 50, customLogo, sx, ...other }, ref) => {
    const logo = (
      <Box
        ref={ref}
        component="img"
        src={customLogo || '/logo/logo-nectar-laranja.png'}
        sx={{
          width,
          height,
          cursor: disabledLink ? 'default' : 'pointer',
          objectFit: 'contain', // Garante que a imagem não seja distorcida
          ...sx,
        }}
        {...other}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href={url} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
